import {  sendApi } from ".";
import { T_Code } from "../model/codeModel";
import { T_Hand } from "../model/handModel";

async function handList(data?: any) {

    const response = await sendApi({
      method: "post",
      url: "/hand/list",
      data: {
        ...data,
      },
    });

    return response;
  }

async function handCreate(data1?:T_Hand){

  const response = await sendApi({
    method: "post",
    url: "/hand/insert",
    isForm:true,
    data: {
      ...data1,
    },
  });

  return response;
}  
async function handEdit(data1?:T_Hand){

  const response = await sendApi({
    method: "post",
    url: "/hand/update",
    isForm:true,
    data: {
      ...data1,
    },
  });

  return response;
}  
async function handDelete(data1?:T_Hand){
 
  const response = await sendApi({
    method: "post",
    url: "/hand/delete",
    data: {
      ...data1,
    },
  });

  return response;
}  

const error = {
    handList,
    handCreate,
    handEdit,
    handDelete,
  };
  export default error;

